export class IhrConfig {
    constructor(config) {
        this.config = config ?? {};
    }

    static async init() {
        try {
            const applicationConfig = await (await fetch('/config.json')).json();

            return new IhrConfig(applicationConfig);
        }
        catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Unable to load application config - ${error}`);
        }

        throw new Error('Unable to load the application configuration.');
    }

    get auth0() {
        const {auth0} = this.config;
        return auth0;
    }

    get auth0ClientId() {
        const {auth0: {clientId} = {}} = this.config;
        return clientId;
    }

    get auth0Domain() {
        const {auth0: {domain} = {}} = this.config;
        return domain;
    }

    get backend() {
        const {services: {backend} = {}} = this.config;
        return backend;
    }

    get datadog() {
        const {services: {datadog} = {}} = this.config;
        return datadog;
    }

    get amplitude() {
        const {amplitude} = this.config;
        return amplitude;
    }

    get amplitudeApiKey() {
        const {amplitude: {apiKey} = {}} = this.config;
        return apiKey;
    }
}
